/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

// tslint:disable:max-classes-per-file
import { Action } from '@ngrx/store';

export const GET_LIBRARY_HIGHLIGHTS = '[Library] Get Library Highlights';
export const GET_LIBRARY_HIGHLIGHTS_SUCCESS = '[Library] Get Library Highlights Success';
export const GET_LIBRARY_HIGHLIGHTS_FAIL = '[Library] Get Library Highlights Fail';
export const ADD_TO_LIBRARY_HIGHLIGHTS = '[Library] Add To Library Highlights';
export const RESET_LIBRARY_HIGHLIGHTS = '[Library] Reset Library Highlights';
export const SET_LAST_VIEWED_HR = '[Library] Set Last VIEWED HR';

export class GetLibraryHighlights implements Action {
  readonly type = GET_LIBRARY_HIGHLIGHTS;
  constructor() {}
}

export class GetLibraryHighlightsFail implements Action {
  readonly type = GET_LIBRARY_HIGHLIGHTS_FAIL;

  constructor(public payload: any) {}
}

export class GetLibraryHighlightsSuccess implements Action {
  readonly type = GET_LIBRARY_HIGHLIGHTS_SUCCESS;

  constructor(public payload: any) {}
}

export class AddToLibraryHighlights implements Action {
  readonly type = ADD_TO_LIBRARY_HIGHLIGHTS;

  constructor(public payload: any) {}
}

export class ResetLibraryHighlights implements Action {
  readonly type = RESET_LIBRARY_HIGHLIGHTS;
  constructor() {}
}

export class SetLastViewedHr implements Action {
  readonly type = SET_LAST_VIEWED_HR;

  constructor(public payload: number) {}
}

export type GetLibraryHighlightsAction =
  | GetLibraryHighlights
  | GetLibraryHighlightsFail
  | GetLibraryHighlightsSuccess
  | AddToLibraryHighlights
  | ResetLibraryHighlights
  | SetLastViewedHr;
